// Tender Evaluation list: status filter metadata and the Excel/CSV export.
// Download helpers are shared with the Plan & Procurement list.

import { downloadSheet } from '../../Procurement/utils/procurementList';

// `value` is the StatusHps query value, `wording` what a row carries in
// evaluationStatusWording. `tone` drives the to-status / to-mcard modifier,
// `stat` the to-stat one.
export const EVALUATION_STATUSES = [
  {
    value: 'Requested',
    wording: 'Ready for Evaluation',
    icon: 'ri-file-search-line',
    tone: 'info',
    stat: 'open',
  },
  {
    value: 'Submitted',
    wording: 'Awaiting Evaluation',
    icon: 'ri-hourglass-line',
    tone: 'danger',
    stat: 'danger',
  },
  {
    value: 'UnderEvaluation',
    wording: 'Under Evaluation',
    icon: 'ri-loader-4-line',
    tone: 'success',
    stat: 'done',
  },
  {
    value: 'Saved',
    wording: 'Saved Evaluation',
    aliases: ['Closing Evaluation', 'Locked Evaluation', 'Evaluation Locked'],
    icon: 'ri-lock-line',
    tone: 'muted',
    stat: 'done',
  },
];

export const getEvaluationStatus = wording => {
  const key = String(wording ?? '')
    .trim()
    .toLowerCase();
  if (!key) return undefined;
  return EVALUATION_STATUSES.find(status => {
    if (status.wording.toLowerCase() === key) return true;
    return (status.aliases ?? []).some(
      alias => String(alias).toLowerCase() === key
    );
  });
};

const toExportRow = row => ({
  'ID Proc': row.idProc || '',
  Title: row.title || '',
  'Proc Type': row.procType || '',
  Product: row.productType?.main || '',
  'Product Type': row.productType?.sub || '',
  Description: row.description || '',
  Status: row.evaluationStatusWording || '',
});

export const exportTenderEvaluationList = (rows, { format, sheetName }) =>
  downloadSheet(rows.map(toExportRow), {
    format,
    prefix: 'TenderEvaluation',
    sheetName,
  });
